'use client';
// ============================================================================
// Shared Components
// ============================================================================
/**
 * HomeFeedContent
 *
 * Shared content for Home feed sidebars - WhoToFollow, ActiveUsers, HotTags, FeedbackCard.
 * Used by both HomeFeedRightSidebar (desktop) and HomeFeedRightDrawer (tablet).
 */
import { Container } from '@/atoms/Container/Container';
import { ActiveUsers } from '../ActiveUsers/ActiveUsers';
import { FeedbackCard } from '../FeedbackCard/FeedbackCard';
import { HotTags } from '../HotTags/HotTags';
import { WhoToFollowSidebar } from '../WhoToFollowSidebar/WhoToFollowSidebar';

function HomeFeedContent() {
  return (
    <>
      <WhoToFollowSidebar />
      <ActiveUsers />
      <HotTags />
      <FeedbackCard />
    </>
  );
}

// ============================================================================
// Home Feed Right Sidebar Components
// ============================================================================

/**
 * HomeFeedRightSidebar
 *
 * Right sidebar for Home feed - displays WhoToFollow, ActiveUsers, HotTags, FeedbackCard.
 * Desktop version.
 */
export function HomeFeedRightSidebar() {
  return <HomeFeedContent />;
}

/**
 * HomeFeedRightDrawer
 *
 * Right drawer for Home feed (tablet) - displays WhoToFollow, ActiveUsers, HotTags, FeedbackCard.
 */
export function HomeFeedRightDrawer() {
  return (
    <Container overrideDefaults className="flex flex-col gap-6">
      <HomeFeedContent />
    </Container>
  );
}

/** Phone feed drawer content; ActiveUsers remains in the tablet and desktop sidebars. */
export function HomeFeedRightDrawerMobile() {
  return (
    <Container overrideDefaults className="flex w-(--filter-bar-width) flex-col gap-6">
      <WhoToFollowSidebar />
      <HotTags />
      <FeedbackCard />
    </Container>
  );
}

// ============================================================================
// Hot Feed Right Sidebar Components
// ============================================================================

/**
 * HotFeedRightSidebar
 *
 * Right sidebar for Hot feed - displays WhoToFollow, FeedbackCard.
 * Desktop version with sticky positioning.
 */
export function HotFeedRightSidebar() {
  return (
    <>
      <WhoToFollowSidebar />
      <Container overrideDefaults className="sticky top-[100px] self-start">
        <FeedbackCard />
      </Container>
    </>
  );
}

/**
 * HotFeedRightDrawer
 *
 * Right drawer for Hot feed (tablet/mobile) - displays WhoToFollow, FeedbackCard.
 */
export function HotFeedRightDrawer() {
  return (
    <Container overrideDefaults className="flex flex-col gap-6">
      <WhoToFollowSidebar />
      <FeedbackCard />
    </Container>
  );
}
